<template>
  <div class="main-wrapper">

    <div class="main-scroll">
      <Navs></Navs>
      <home></home>
      <Foots class="foots"></Foots>
    </div>
    <bottom-backtop></bottom-backtop>

  </div>
</template>
<script>
import Navs from '../common/navs'
import Foots from '../common/foots'
import home from './myNews'
import {messageData}  from '../request/api.js'
import BottomBacktop from '../common/BottomBacktop';


export default {
  components: {
    Navs,
    Foots,
    home,
    BottomBacktop
  },
  name: 'recruitList',
  data() {
    return {
      messageList:[]
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData(){
      messageData({}).then(response=>{
        this.messageList = response.data
      })
    }
  }

}
</script>
<style lang="scss" scoped>

</style>
